<template>
  <metainfo>
    <template v-slot:title="{ content }">{{ content }}</template>
  </metainfo>
  <transition name="fade" mode="in-out">
    <component :is="layout" />
  </transition>
</template>
<script>
import { useStore } from 'vuex'
// import { setOptions, bootstrap } from 'vue-gtag'
import { useRouter } from 'vue-router'
import { ref, shallowRef, defineAsyncComponent, computed, onMounted } from 'vue'
import { useMeta, useActiveMeta } from 'vue-meta'
// import axios from 'axios'
// Load layout components dynamically.
const requireContext = require.context('~/layouts', true, /.*\.vue$/, 'sync')
const componentNames = requireContext.keys().map((file) => file.replace(/(^.\/)|(\.vue$)/g, ''))
const components = {}
componentNames.forEach((component) => { // component represents the component name
  components[component] = defineAsyncComponent(() => // import each component dynamically
    import('@/layouts/' + component + '.vue')
  )
})
export default {
  components,
  setup () {
    useMeta({
      title: process.env.VUE_APP_TITLE
    })
    const store = useStore()
    const metainfo = useActiveMeta()
    const router = useRouter()
    const layout = shallowRef(null)
    const defaultLayout = ref('default')
    const defaultTitle = computed(() => {
      return process.env.VUE_APP_TITLE
    })
    router.beforeEach(beforeEach)
    function beforeEach (to, from, next) {
      const l = to.meta.layout
      if (typeof l === 'undefined') {
        layout.value = defaultLayout.value
      }
      layout.value = components[l]
      return next()
    }
    onMounted(() => {
      initStat()
      // Gtag
      // getConfigGt()
    })
    function initStat () {
      // 'https://shop.loewe-pergola.de/?fbclid=IwAR1gG07KxVm3WB1CqckrxNOI_4UvNd7B0SSxilw6O09a_eKZEuRzrXRnnqs'
      const url = document.referrer
      store.dispatch('stats/setReferrerUrl', url)
    }
    // get google tag id
    /*
    async function getConfigGt () {
      const apiKey = btoa(process.env.VUE_APP_API_KEY)
      const apiUrl = process.env.VUE_APP_API_URL
      await axios.post(apiUrl + 'configs/all', { re: apiKey, name: 'google_tag_id' }).then(resp => {
        if (resp.data !== null) {
          enableGtag(resp.data.value)
        }
      })
    }
    function enableGtag (gt) {
      if (gt) {
        setOptions({
          config: { id: gt }
        })
        bootstrap().then((gtag) => {
          // all done
        })
      }
    }
    */
    return {
      layout,
      metainfo,
      defaultTitle
    }
  }
}
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
